import api from '../../../config';

const path = 'v1/asset-standard/typ';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
